import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=5b977840&scoped=true&lang=pug&"
import script from "./count-down.vue?vue&type=script&lang=js&"
export * from "./count-down.vue?vue&type=script&lang=js&"
import style0 from "./count-down.vue?vue&type=style&index=0&id=5b977840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b977840",
  null
  
)

export default component.exports